/* eslint-disable camelcase */
import PropTypes from 'prop-types';

import {
  propTypesAltLanguage,
  propTypesEventAuthor,
  propTypesFAQContent,
  propTypesIllustration,
  propTypesReviews,
  propTypesTextHtml,
} from '../../shared/constants/Proptypes';
import { propTypesEventTag } from '../EventTag/EventTag.proptypes';

export const propTypesEvent = {
  last_publication_date: PropTypes.string,
  first_publication_date: PropTypes.string,
  lang: PropTypes.string,
  url: PropTypes.string,
  uid: PropTypes.string,
  type: PropTypes.string,
  alternate_languages: PropTypes.shape(propTypesAltLanguage),
  data: PropTypes.shape({
    body: PropTypes.shape({}),
    breadcrumb_title: PropTypes.string,
    description: PropTypes.string,
    event_author: PropTypes.shape({
      document: PropTypes.shape(propTypesEventAuthor),
    }),
    event_slides: PropTypes.arrayOf(
      PropTypes.shape({
        event_slide: PropTypes.shape(propTypesIllustration),
      })
    ),
    event_slug: PropTypes.string,
    faq_content: PropTypes.shape(propTypesFAQContent),
    illustration: PropTypes.shape(propTypesIllustration),
    meta_description: PropTypes.string,
    meta_title: PropTypes.string,
    number_of_questions: PropTypes.string,
    og_description: PropTypes.string,
    publication_date: PropTypes.string,
    reviews: PropTypes.shape(propTypesReviews),
    tags: PropTypes.arrayOf(
      PropTypes.shape({
        tag: PropTypes.shape({
          document: PropTypes.shape(propTypesEventTag),
        }),
      })
    ),
    title: PropTypes.shape(propTypesTextHtml),
  }),
};
